import { gql } from '@edreamsodigeo/frontend-api-client';

export const GET_USER_ACCOUNT = gql`
  query GetUserAccount($userAccountRequest: UserAccountRequest) {
    userAccount(userAccountRequest: $userAccountRequest) {
      isLoggedIn
      userMembership {
        isActive
        accountDetails {
          names
        }
        subscriptionDetails {
          isAutoRenewalEnabled
          currentPlanDetails {
            tier
          }
        }
      }
    }
  }
`;

export default GET_USER_ACCOUNT;
